import { useEffect, useState } from 'react';
import { supabase } from '../lib/webSite';

export default function useOpenPositions() {
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!supabase) return;
      try {
        const { data, error } = await supabase
          .from('open_positions')
          .select('id, title, tags, apply_email, sort_order, is_active')
          .eq('is_active', true)
          .order('sort_order', { ascending: true })
          .order('created_at', { ascending: true });

        if (error) throw error;
        if (!cancelled) setPositions(data || []);
      } catch (err) {
        console.warn('Could not load open_positions.', err);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return positions;
}
